import { Phone } from 'lucide-react'
import { SUPPORT_PHONE_DISPLAY, SHOW_SUPPORT_PHONE } from '../../lib/contact'
import { TextUsLink } from '../TextUsLink'

export function MobileCallBar() {
  if (!SHOW_SUPPORT_PHONE) return null

  return (
    <TextUsLink className="sm:hidden fixed bottom-0 inset-x-0 z-40 flex items-center justify-center gap-2 bg-emergency-600 text-white font-bold py-3.5 shadow-[0_-2px_10px_rgba(0,0,0,0.15)]">
      <Phone className="h-4 w-4" />
      Text us now · {SUPPORT_PHONE_DISPLAY}
    </TextUsLink>
  )
}
